import { useCallback } from 'react';

const useCssVars = () => {
  const setCssVar = useCallback((name: string, value: string) => {
    const formattedName = name.startsWith('--') ? name : `--${name}`;
    document.documentElement.style.setProperty(formattedName, value);
  }, []);

  const getCssVar = useCallback((name: string) => {
    const formattedName = name.startsWith('--') ? name : `--${name}`;
    return getComputedStyle(document.documentElement)
      .getPropertyValue(formattedName)
      .trim();
  }, []);

  return { setCssVar, getCssVar };
};

export default useCssVars;
